"use client";

import { type ReactNode, useLayoutEffect, useState } from "react";

import { requiresMygaDocumentNavigation } from "@/lib/myga-application/privacy";
import { useAppPathname } from "@/ui/app-link/app-link";

export function MygaDocumentBoundary(props: { children: ReactNode }) {
  const pathname = useAppPathname();
  const [initialPath] = useState(pathname);
  const reload = requiresMygaDocumentNavigation(initialPath, pathname);
  useLayoutEffect(() => {
    if (reload) {
      window.location.reload();
    }
  }, [reload]);
  return reload ? null : props.children;
}
